import { Box } from '@chakra-ui/react';
import { AppHeader, TableComponent } from '@components/index';
import { StyledDashboardLayoutChildContainer } from '@root/components/common/style';
import { LANGUAGE } from '@root/constants';
import { TABLE_ITEM_LAYOUT_TYPE } from '@root/constants/common';
import { PRIVACY_CONTENT } from '@root/constants/privacy-content';
import { getCurrentLanguage } from '@root/store/selectors/features';
import { t } from 'i18next';
import React from 'react';
import { useSelector } from 'react-redux';


export const PrivacyPolicy: React.FC = () => {
  const currentLanguage = useSelector(getCurrentLanguage);

  return (
    <StyledDashboardLayoutChildContainer
      flex={1}
    >
      <AppHeader
        title={t('common:sideMenu.privacy')}
        minH={'83px'}
      />
      <Box
        height={'100%'}
        overflowY={'scroll'}
        padding={'16px'}
      >
        <TableComponent
          tableData={currentLanguage === LANGUAGE.ENGLISH ? PRIVACY_CONTENT.CONTENT_EN : PRIVACY_CONTENT.CONTENT_KO}
          itemType={TABLE_ITEM_LAYOUT_TYPE.PRIVACY_POLICY}
        />
      </Box>
    </StyledDashboardLayoutChildContainer>
  );
};

